import { WorkflowTriggerTypes } from 'src/app/models/RestApiCaller/Enums/workflow-trigger-types';
import { AttributeChangedTriggerData } from './attribute-change-trigger-data';
import { DateReachedTriggerData } from './date-reached-trigger-data';
import { ExpiredDelayTriggerData } from './expire-delay-trigger-data';
import { FolderCreatedTriggerData } from './folder-created-trigger-data';
import { NodePosition } from './node-position';
import { StepActivatedTriggerData } from './step-activated-trigger-data';
import { StepCompletedTriggerData } from './step-complete-trigger-data';
import { StepStateChangedTriggerData } from './step-state-change-trigger-data';
import { TimerTriggerData } from './timer-trigger-data';
import { AnyTriggerData } from './Types/any-trigger-data';

/**
 * Represente un trigger de workflow.
 */
export class Trigger {
    /**
     * Id du trigger.
     */
    public id: number;

    /**
     * Données du trigger.
     */
    public data: AnyTriggerData;

    // /**
    //  * Données du trigger.
    //  */
    // private _typedData: object;

    // /**
    //  * Obtient les données du trigger.
    //  */
    // public get typedData(): object {
    //     if (!this._typedData) {
    //         this._typedData = JSON.parse(this.data);
    //     }

    //     return this._typedData;
    // }

    /**
     * Constructeur.
     * @param type : Type de trigger de workflow.
     * @param position : Position du noeud affichant le trigger dans le designer.
     */
    public constructor(
        public type: WorkflowTriggerTypes,
        public position: NodePosition
    ) {}

    /**
     * Retourne une copie d'une instance de Trigger
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: Trigger) {
        if (!!other) {
            const instance = new Trigger(other.type, other.position);
            instance.id = other.id;

            let dataObject = other.data;

            if (typeof dataObject === 'string') {
                dataObject = JSON.parse(dataObject);
            }

            switch (instance.type) {
                case WorkflowTriggerTypes.AttributeChanged:
                    instance.data = AttributeChangedTriggerData.clone(dataObject as AttributeChangedTriggerData);
                    break;
                case WorkflowTriggerTypes.DateReached:
                    instance.data = DateReachedTriggerData.clone(dataObject as DateReachedTriggerData);
                    break;
                case WorkflowTriggerTypes.DelayExpired:
                    instance.data = ExpiredDelayTriggerData.clone(dataObject as ExpiredDelayTriggerData);
                    break;
                case WorkflowTriggerTypes.FolderCreated:
                    instance.data = FolderCreatedTriggerData.clone(dataObject as FolderCreatedTriggerData);
                    break;
                case WorkflowTriggerTypes.StepActivated:
                    instance.data = StepActivatedTriggerData.clone(dataObject as StepActivatedTriggerData);
                    break;
                case WorkflowTriggerTypes.StepCompleted:
                    instance.data = StepCompletedTriggerData.clone(dataObject as StepCompletedTriggerData);
                    break;
                case WorkflowTriggerTypes.StepStateChanged:
                    instance.data = StepStateChangedTriggerData.clone(dataObject as StepStateChangedTriggerData);
                    break;
                case WorkflowTriggerTypes.Timer:
                    instance.data = TimerTriggerData.clone(dataObject as TimerTriggerData);
                    break;
            }

            instance.data.id = instance.id;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de Trigger
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: Trigger[]) {
        if (!!others) {
            let triggers: Trigger[] = [];

            others.forEach((x) => {
                const trigger = Trigger.clone(x);
                triggers.push(trigger);
            });

            return triggers;
        } else {
            return [];
        }
    }
}
